import React, { useState } from "react";
import { FormValues } from "./types";
import { useFormContext } from "react-hook-form";
import { CsvUpload } from "./CsvUpload";
import { StudentFilters } from "./BasicInformationPage/StudentFilters";

export const BasicInformationPage = () => {
  const { getValues } = useFormContext<FormValues>();

  const [filterType, setFilterType] = useState<string>(
    getValues("filters.userIds")?.length ? "csvImport" : "studentFilters",
  );

  return (
    <div className="flex flex-col">
      {filterType === "studentFilters" ? (
        <StudentFilters filterType={filterType} setFilterType={setFilterType} />
      ) : (
        <CsvUpload filterType={filterType} setFilterType={setFilterType} />
      )}
    </div>
  );
};
